module.exports = __webpack_public_path__ + "img/flag.f2bc6371.svg";